const ComplementoArrendamientoenfideicomisoRules  = {
  PagProvEfecPorFiduc: [
      'required',
      'decimal:6',
  ],
  RendimFideicom: [
      'required',
      'decimal:6',
  ],
  DeduccCorresp: [
      'required',
      'decimal:6',
  ],
  MontTotRet: [
      'decimal:6',
  ],
  MontResFiscDistFibras: [
      'decimal:6',
  ],
  MontOtrosConceptDistr: [
      'decimal:6',
  ],
  DescrMontOtrosConceptDistr: [
      'string',
      'max:255'
  ],
};

export default ComplementoArrendamientoenfideicomisoRules;